import { en } from './en.js'
import { novelEs } from './novel-es.js'
import { novelComparisonEs } from './novel-comparison.js'
import { novelShellEs, withNovelShell } from './novel-shell.js'

export const es = structuredClone(en)

es.visualGameAdmin.conversionFunnelDevices = {'label': 'Dispositivos de origen', 'all': 'Todos', 'desktop': 'Ordenador', 'mobile': 'Móvil', 'tablet': 'Tableta'}

es.visualGameAdmin.pageFunnel = {'button': 'Ver embudo de páginas', 'title': 'Embudo de páginas', 'home': 'Inicio', 'auth': 'Acceso o registro', 'game': 'Página de juego', 'note': 'Sesiones que recorren los pasos en orden según fecha y dispositivo. Incluye el diálogo de acceso del PC. No se recuperan aperturas históricas sin seguimiento.', 'loading': 'Cargando…', 'error': 'Error al cargar', 'sessions': 'sesiones'}

es.visualGameAdmin.pageFunnel.viewUsers = 'Ver usuarios'
es.visualGameAdmin.pageFunnel.peopleUnit = 'usuarios'
es.visualGameAdmin.pageFunnel.timesUnit = 'veces'

es.visualGameAdmin.pageFunnel.userFilter_all = 'Embudo: registros o accesos'

es.visualGameAdmin.pageFunnel.userFilter_sign_up = 'Embudo: registros del período'

es.visualGameAdmin.pageFunnel.userFilter_login = 'Embudo: accesos del período'

es.visualGameAdmin.usageActivity = {
  "title": "Uso del sitio · Actividad",
  "button": "Ver detalles",
  "all": "Todas las actividades",
  "search": "Buscar usuario, juego o ID",
  "user": "Usuario",
  "game": "Juego",
  "kind": "Actividad",
  "status": "Estado",
  "time": "Fecha",
  "detail": "Ver registro",
  "empty": "No hay registros",
  "loading": "Cargando…",
  "error": "Error al cargar",
  "note": "Las entradas usan eventos propios y pueden diferir de GA4. No se infieren textos ni partidas no registrados.",
  "limit": "Se muestran los últimos 1000 registros. Reduzca el intervalo para ver otros.",
  "text_input": "Entrada de texto",
  "voice_input": "Entrada de voz",
  "slice_video": "Generación de clip",
  "global_video": "Generación de vídeo completo",
  "free_game": "Generación de juego gratis"
}

Object.assign(es.visualGameAdmin.usageActivity, {
  "status_queued": "En cola",
  "status_running": "En curso",
  "status_ready": "Completado",
  "status_failed": "Fallido",
  "status_submitting": "Enviando",
  "status_submitted": "Enviado",
  "status_ok": "Correcto",
  "status_error": "Fallido",
  "status_generating": "Generando",
  "status_generation_failed": "Generación fallida",
  "status_pending_review": "Pendiente de revisión",
  "status_review_rejected": "Rechazado",
  "status_published": "Publicado",
  "status_archived": "Archivado"
})

es.visualGameAdmin.usageActivity.records = 'registros'

es.visualGameAdmin.paypointActivity = {
  "title": "Puntos de pago · Detalles",
  "all": "Todos",
  "game": "Página",
  "kind": "Contexto de pago",
  "status": "Motivo",
  "note": "Los eventos propios pueden diferir de GA4. Abrir el diálogo de vídeo no indica saldo insuficiente. Los registros históricos no incluyen saldo, coste ni ID de partida.",
  "billing_paypoint_gameplay": "Juego",
  "billing_paypoint_ending_video": "Vídeo final",
  "billing_paypoint_story_video": "Vídeo de historia",
  "status_insufficient_balance": "Créditos insuficientes",
  "status_dialog_open": "Diálogo de generación abierto"
}

es.visualGameAdmin.paypointActivity.search = 'Buscar usuario, página o ID'

es.visualGameAdmin.orderDrilldown = {
  "button": "Ver pedidos",
  "dateField": "Referencia temporal",
  "created_at": "Fecha de creación",
  "paid_at": "Fecha de pago"
}

Object.assign(es.visualGameAdmin.orderDrilldown, {
  "since": "Fecha inicial",
  "until": "Fecha final"
})

es.visualGameAdmin.orderDrilldown.updated_at = 'Fecha de actualización del estado'

es.visualGameAdmin.trafficBaseline = {
  "confirmed": "Incremento confirmado",
  "first": "Vistas de primera captura (sin referencia histórica)",
  "missing": "Sin referencia; incremento incompleto",
  "note": "Los vídeos publicados durante el intervalo parten de cero e incluyen la primera captura en el incremento. En vídeos anteriores o sin fecha de publicación y sin captura previa, las primeras vistas se muestran por separado. La fecha de captura no es la de publicación.",
  "observed": "Primera observación",
  "filter": "Sin referencia",
  "unchanged": "Sin crecimiento (referencia completa)",
  "later": "Crecimiento tras primera observación"
}

es.visualGameAdmin.funnelAuth = {
  registration: 'Registros del sitio',
  login: 'Accesos al sitio',
  new_users: 'Accesos de nuevos usuarios',
  existing_users: 'Accesos de usuarios existentes',
  note: 'Los nuevos usuarios se registraron en el período seleccionado; los existentes, antes. Se incluye el inicio automático tras registrarse. Los usuarios se deduplican; las veces incluyen el inicio automático y los posteriores. Registro e inicio se solapan y no deben sumarse.',
  user_type: 'Tipo de usuario',
  registered_at: 'Fecha de registro',
  new_type: 'Nuevo usuario',
  existing_type: 'Usuario existente',
  auto_login: 'Inicio automático tras el registro'
}

es.visualGameAdmin.funnelPeriods = {
  yesterday: 'Ayer',
  last_three_days: 'Últimos 3 días'
}

es.visualGameAdmin.videoExport = {
  button: 'Exportar lista actual CSV',
  published_sort: 'Por fecha de publicación',
  published_label: 'Publicado el',
  unknown: 'Sin registrar'
}

withNovelShell(es.visualGameAdmin, novelShellEs)
Object.assign(es.visualGameAdmin, novelEs, { novelComparison: novelComparisonEs })

es.visualGameAdmin.storyFilmPromptReview = {
      title: 'Revisión de prompts del drama',
      subtitle: 'Revisión de contenido de los prompts finales por plano y sus parámetros. Aprobar el contenido no es llamar a H3 ni deja un vídeo reproducible.',
      gateNotice: 'La aprobación cubre solo prompt y plan. Las llamadas H3 del proveedor siguen bajo un control separado de presupuesto/límite; ahora están no autorizadas y no hay botón de llamada.',
      loading: 'Cargando…',
      empty: 'Aún no hay paquetes',
      filters: {
      status: 'Estado de revisión',
      all: 'Todos',
      owner: 'Jugador (owner)',
      ownerPlaceholder: 'user id',
      run: 'Partida',
      runPlaceholder: 'run_id',
      branch: 'Rama',
      branchPlaceholder: 'branch_id',
      season: 'Temporada',
      seasonPlaceholder: 'season_id',
      episode: 'Episodio',
      episodePlaceholder: 'episode_id',
      planDigest: 'Versión de plan',
      planDigestPlaceholder: 'plan_digest',
      version: 'Versión del paquete',
      versionPlaceholder: 'n.º de versión',
    },
      actions: {
      search: 'Buscar',
      clear: 'Limpiar filtros',
      view: 'Ver',
      more: 'Cargar más',
      approve: 'Aprobar contenido',
      reject: 'Devolver para revisión',
      rejectPlaceholder: 'Motivo (obligatorio)',
      regenerate: 'Nueva versión',
      simulatedNotification: 'Ver notificaciones simuladas',
    },
      validation: {
      limit: '{count}/{max} caracteres (sin espacios al principio y al final)',
      required: 'Introduce un motivo antes de devolver el paquete.',
      too_long: 'El motivo admite hasta {max} caracteres. Acórtalo antes de enviar; el paquete no se ha devuelto.',
      invalid_body: 'No se aceptó el motivo. Revisa el texto: {message}',
    },
      notice: {
      approve: 'Contenido aprobado; sin llamada H3 ni cargo.',
      reject: 'Devuelto con motivo registrado.',
      regenerate: 'Nueva versión creada; revise de nuevo.',
    },
      columns: {
      episode: 'Episodio',
      version: 'Versión',
      status: 'Estado',
      shots: 'Planos',
      duration: 'Duración',
      digest: 'Resumen del paquete',
      createdAt: 'Creado',
    },
      status: {
      draft: 'Pendiente',
      in_review: 'En revisión',
      approved: 'Aprobado',
      rejected: 'Devuelto',
      superseded: 'Reemplazado',
    },
      detail: {
      title: 'Paquete #{id} · v{version}',
      owner: 'Jugador',
      film: 'Obra',
      season: 'Temporada',
      episode: 'Episodio',
      run: 'Partida',
      branch: 'Rama',
      range: 'Rango de turnos',
      sourceVersion: 'Versión de origen',
      snapshot: 'Instantánea',
      planDigest: 'Resumen del plan',
      packDigest: 'Resumen del paquete',
      planVersion: 'Versión paquete/plan',
      cutPolicy: 'Versión de política de corte',
      costModel: 'Versión del modelo de coste',
      gate: 'Controles',
      gateValue: 'Presupuesto={budget} · modelo de coste={cost} · puntos previstos={points} · soporte de prompt negativo={negative}',
      provider: 'Proveedor',
      providerValue: '{provider} / {model} · {size} · steps={steps} · turbo={turbo} · cola={priority} · {shots} planos',
      shotsTitle: 'Paquete por plano',
      chars: '{count} caracteres',
      sendable: 'Enviable',
      notSendable: 'No enviable',
      blocked: 'Motivos de bloqueo',
      promptTitle: 'Prompt positivo final',
      requestTitle: 'Parámetros de solicitud (solo campos verificados)',
      evidenceTitle: 'Evidencia de origen (visible para el jugador)',
      anchorsTitle: 'Anclas de personaje/escena',
      speakers: 'Personajes',
      locations: 'Escenas',
      references: 'Materiales de referencia',
      negativeTitle: 'Prompt negativo (revisión de contenido; campo del proveedor sin verificar)',
      negativeGate: 'El prompt negativo no forma parte de la solicitud enviable: el adaptador H3 actual no verifica ese campo.',
      episodeSummary: 'Planos {shots} · duración {duration}ms · fotogramas {frames} · cuantización {frameMs}ms · tope total {caps}ms',
      quoteSummary: 'Instantánea de cotización: {status} · puntos previstos {points} · coeficiente {ppm}ppm · {currency}',
      cost: 'Coste previsto: {points}',
      costUnapproved: 'sin aprobar',
    },
      events: {
      title: 'Historial de revisión',
    },
    }

es.visualGameAdmin.storyFilmPromptReview.simulatedPage = {
      title: 'Vista previa de notificaciones simuladas',
      subtitle: 'Revisión con carga simulada fija; sin lecturas/escrituras de BD, correos ni cargos.',
      isolation: 'Esta página está aislada del ready outbox real, medios, estado de primera gratuidad y SMTP; sin reproducción ni reembolsos reales.',
      back: 'Volver a la revisión de prompts',
    }
es.visualGameAdmin.storyFilmPromptReview.detail.trim = 'plan {plan}ms / genera {gen}ms (recorta el exceso)'

es.visualGameAdmin.storyFilmPromptReview.detail.providerValue = '{provider} / {model} · {size} · {aspect} · móvil {fit} · capacidad {capability} · steps={steps} · turbo={turbo} · cola={priority} · {shots} planos'

es.visualGameAdmin.storyFilmPromptReview.detail.episodeSummary = 'Planos {shots} · plan {duration}ms · fotogramas {frames} · cuantización {frameMs}ms · tope total {caps}ms · H3 {h3fps}fps'
es.visualGameAdmin.storyFilmPromptReview.detail.selection = 'Contrato de selección A'

es.visualGameAdmin.storyFilmPromptReview.detail.selectionValue = '{status} · {version} · {units} unidades · omitidos {omitted} caracteres · {digest}'
es.visualGameAdmin.storyFilmPromptReview.detail.selectionArc = 'Evidencia de cierre settlement={settlement} · ending={ending} · opening={opening} · climax={climax} · resolution={resolution}'
es.visualGameAdmin.storyFilmPromptReview.detail.generation = 'Corte final {final}ms / generación {gen}ms / cap {cap}ms'

es.visualGameAdmin.storyFilmPromptReview.detail.capExceeded = 'La generación excede el cap en {over}ms; no enviable'

es.visualGameAdmin.storyFilmPromptReview.detail.durationSplit = 'Final {final}ms / generación {gen}ms / cap {cap}ms / planos excedidos {exceeded}'
